
define('template!editPimOptionTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="code">\n    ';
 if(enableOnOff) { ;
__p += '\n    <input type="checkbox" class="cbx-enable-opt" ' +
((__t = ( activated===false?'':'checked' )) == null ? '' : __t) +
' />\n    ';
 } ;
__p += '\n    ' +
((__t = ( code )) == null ? '' : __t) +
'\n</div>\n<div class="name">' +
((__t = ( name )) == null ? '' : __t) +
' <div class="glossary-dt-value opt-name-region"></div></div>\n<div class="color">\n    ';
 if(color !== '') { ;
__p += '\n        <div class="color-round" style="background-color:' +
((__t = ( color )) == null ? '' : __t) +
'"></div>\n    ';
 } ;
__p += '\n</div>\n';

    var css = '';
    if(allowUpload) {
        css = 'context-menu-option';
    }
;
__p += '\n<div class="images">\n    ';
 _.each(images, function (url, index) { ;
__p += '\n        <div class=\'image\'>\n            ';
 if (defaultIndexPicture === (index + 1)) { ;
__p += '\n            <i class="mdi-action-bookmark" style="position:absolute; font-size: 13px; color: green;"></i>\n            ';
 } ;
__p += '\n            <img data-index="' +
((__t = ( index+1 )) == null ? '' : __t) +
'" data-link="' +
((__t = ( url )) == null ? '' : __t) +
'" class="jq-picture js-image-cell ' +
((__t = ( css )) == null ? '' : __t) +
'" src="' +
((__t = ( url )) == null ? '' : __t) +
'"/>\n        </div>\n    ';
 });;
__p += '\n</div>\n';

}
return __p
};});

